import React from 'react'
import PropTypes from 'prop-types'
import './hero.css'

const Hero = (props) => {
  return (
    <div className={`hero-container1 ${props.rootClassName}`}>
      <div className="hero-container2">
        <div className="hero-container3">
          <img alt="Help Me Out Logo" src="/hmol%20logo-1500w.png" className="hero-image" />
        </div>
        <div className="hero-container4">
          <span className="hero-eyebrow">Financial Support</span>
          <h1 className="hero-thq-heading-elm">Welcome To Help Me Out</h1>
          <h2 className="hero-thq-sub-heading-elm">
            We are dedicated to providing you with the financial support you need, when you need it most.
          </h2>
          <div className="hero-container5">
            <a href="#prequalifying" className="hero-container6">
              <span className="hero-text1">Apply Now</span>
            </a>
            <a href="https://hmoloan.quinnpay.com/Account/Login" target="_blank" rel="noreferrer noopener" className="hero-container7">
              <span className="hero-text2">Login</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

Hero.defaultProps = { rootClassName: '' }
Hero.propTypes = { rootClassName: PropTypes.string }

export default Hero
